import type {
  CollectGraphqlFilters,
  CollectsCollection,
} from '~/types/graphql-backend-types/gql-types'
import { useQuery } from '@tanstack/vue-query'
import gql from 'graphql-tag'

export function useBSDCollect(filters: CollectGraphqlFilters) {
  const { query } = useGqlMikro()
  const { isAdmin } = storeToRefs(useAuthStore())

  return useQuery({
    queryKey: ['bsd-collect', { filters }],
    queryFn: async () => {
      const { data, errors } = await query({
        query: BSD_COLLECT_QUERY,
        variables: {
          pagination: {},
          filters,
          isAdmin: isAdmin.value,
        },
      })

      if (errors) {
        throw new Error(errors[0].message)
      }

      return JSON.parse(JSON.stringify(data.collects)) as CollectsCollection
    },
  })
}

const BSD_COLLECT_QUERY = gql`
query BSDOnCollect($pagination: PaginationArgs!, $filters: CollectGraphqlFilters, $isAdmin: Boolean!) {
  collects(pagination: $pagination, filters: $filters) {
    count
    collection {
      ...AdminFields @include(if: $isAdmin)
      licensePlate
      endsAt
      id
      client {
        name
        id
      }
      recycler {
        id
        name
      }
      BSDs {
        count
        collection {
          id
          tdState
          publicState
          errors
          __typename
          TDViewBSDUri
          collectedContainers {
            id
            quantity
            treatmentCode
            unit
            material {
              id
              name
            }
            container {
              name
              id
            }
          }
        }
        __typename
      }
    }
  }
}
`
